import BusImage from "../assets/images/bus.png";

const About = () => {
  return (
    <div>
      <div className="container mx-auto pt-24 md:pt-36 pb-12 px-5 text-black">
        <div className="flex flex-col gap-3 mb-7">
          <div className="head text-4xl font-bold">ABOUT</div>
          <div className="flex items-center text-4xl font-bold head gap-3">
            <span className="text-pry"> CROSS COUNTRY</span>
            <div className="h-2 w-4 bg-black"></div>
          </div>
        </div>
        <img src={BusImage} alt="" className="mb-10" />
        <div className="flex flex-col md:flex-row gap-2 md:gap-0 items-start border-b py-10">
          <div className="flex items-center text-2xl font-bold gap-3 md:w-[20%]">
            <div className="h-2 w-4 bg-black"></div>
            <div className="head flex gap-1">
              <div>Our</div> <span className="text-pry">Story</span>
            </div>
            <div className="h-2 w-4 bg-black"></div>
          </div>
          <div className="text-base font-medium leading-7 md:w-[80%]">
            Cross Country Limited is a First Class Transportation and Logistics
            Company Operating in Nigeria and the ECOWAS sub region. It is a one
            stop logistics shop company that runs comprehensive land
            Transportation, Haulage and Courier Services for Corporate
            Organizations and individuals at highly competitive prices. It also
            provides quality and prompt bus rental services across the country
            at affordable prices whilst making sure that our customers enjoy
            real value for their money. <br />
            <br /> The company is an indigenous company having on board
            internationally trained and exposed men with verifiable track
            records in their various chosen fields. Cross country came with a
            vision to completely transform the transportation industry in
            Nigeria by providing a world class mass Transportation, Haulage and
            Courier Services that is highly dependable for safety, promptness
            and efficient service delivery that delight our customers. <br />
            <br /> Cross Country Limited was incorporated on May 2, 2001, with
            RC: 409063 to carry on the business of proprietors and carrier of
            goods and passengers. The company was also licensed (No 163) by the
            Courier Regulatory Department (CRD) of Nigerian Postal Services
            (NIPOST) to practice Courier and Haulage Services. <br />
            <br /> The Company with its corporate head office at 345, Muritala
            Mohammed way, yaba, Lagos, Nigeria commences operations of intercity
            and intracity transportations in December 2002 with fleet of 132
            vehicles. Cross Country started up as a small scale Commercial
            Transportation company but now it has grown big and has
            international recognition. The company has the largest
            transportation network in Nigeria as its branches are located in all
            the six Geo-political zones of the country serving more than 30
            destinations in Nigeria and some neighboring African Countries. The
            company currently has a fleet of 500 vehicles with an average age of
            8 years and they are of high capacity for efficient and effective
            services. Cross Country is a member of Association of Luxury Bus
            Owners of Nigeria (ALBON) and Association of Nigerian courier
            operators (ANCO). <br />
            <br /> For the company remarkable achievement in transportation and
            logistics, Cross Country Limited was adjudged the Best Transporter
            in Nigeria by the Chartered Institute of Transport, Nigeria and has
            since then consistently won the National Bus Operator of the year
            award along with other accolades by renowned bodies. Most recent of
            such is Nigeria’s Best Travel Portal at the Voyage Awards 2018.
          </div>
        </div>
        <div className="flex flex-col md:flex-row gap-2 md:gap-0 items-start  border-b py-10">
          <div className="flex items-center text-2xl font-bold gap-3 md:w-[20%]">
            <div className="h-2 w-4 bg-black"></div>
            <div className="head flex gap-1">
              <div>Our</div> <span className="text-pry">Mission</span>
            </div>
            <div className="h-2 w-4 bg-black"></div>
          </div>
          <div className="text-base font-medium leading-7 md:w-[80%]">
            Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
            eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim
            ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut
            aliquip ex ea commodo consequat. Duis aute irure dolor in
            reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla
            pariatur. Excepteur sint occaecat cupidatat non proident, sunt in
            culpa qui officia deserunt mollit anim id est laborum.
          </div>
        </div>
        <div className="flex flex-col md:flex-row gap-2 md:gap-0 items-start  border-b py-10">
          <div className="flex items-center text-2xl font-bold gap-3 md:w-[20%]">
            <div className="h-2 w-4 bg-black"></div>
            <div className="head flex gap-1">
              <div>Our</div> <span className="text-pry">Vision</span>
            </div>
            <div className="h-2 w-4 bg-black"></div>
          </div>
          <div className="text-base font-medium leading-7 md:w-[80%]">
            Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
            eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim
            ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut
            aliquip ex ea commodo consequat. Duis aute irure dolor in
            reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla
            pariatur. Excepteur sint occaecat cupidatat non proident, sunt in
            culpa qui officia deserunt mollit anim id est laborum.
          </div>
        </div>
        <div className="flex justify-center mt-16">
          <div className="flex items-center  text-2xl font-bold gap-3">
            <div className="h-2 w-4 bg-black"></div>
            <div className="head flex gap-1">
              <div>Fleet</div> <span className="text-pry">Gallery</span>
            </div>
            <div className="h-2 w-4 bg-black"></div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;
